var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.nudgeWrapper},_vm._l((_vm.nudgeComponents),function(nudgeComponent){return _c(nudgeComponent.component,_vm._b({key:nudgeComponent.key,tag:"component",attrs:{"data-test-id":"ViewportNudge_nudgeComponent"}},'component',nudgeComponent.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }